import Stack from '@mui/material/Stack';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { blue } from '@mui/material/colors';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import products from '../../data/computer'

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[400],
  '&:hover': {
    backgroundColor: blue[850],
  },
}));

let dateNow = new Date().getTime()
let arrayTrue = []

//verifica se a licença já expirou 
let dataValidation = products.map((row) => (
  (new Date(Date.parse(row.expirate)).getTime())) > dateNow ?
  row.licenca :
  null
)

dataValidation.map((a, i) => (
  a != null ?
    arrayTrue[i] = a :
    ''
))
const result = arrayTrue.filter(e => e);

export default function CustomizedButtonsLicencas() {
  return (
    <Stack spacing={2} direction="row">
      <ColorButton
        style={{ minWidth: '65%', minHeight: '3.5rem' }}
        startIcon={<VpnKeyIcon></VpnKeyIcon>}
        size="larger" variant="contained">Licenças ativas: {result.length}
      </ColorButton>
    </Stack>
  );
}